


import React, { useState, useEffect, useContext } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate } from "react-router-dom";
import { contentContext } from "../context/contentContext";
import axios from "axios";
import { keyActivate } from "../utils/a11y";


let {lambda,appname}=window.app;

const GeneratePassword = () => {
   // let { id } = useParams();
   const navigate = useNavigate();
   const [passwordError, setPasswordErr] = useState("");
   const [confirmPasswordError, setConfirmPasswordError] = useState("");
   const [passwordShown, setPasswordShown] = useState(false);
   const [number, setNumber] = useState(false);
   const [upper, setUpper] = useState(false);
   const [limit, setLimit] = useState(false);
   const [lower, setLower] = useState(false);
   const [special, setSpecial] = useState(false);
   const[image,setImg]=useState("")
   const [error, setError] = useState('');
   const[showPwd,setShowPwd]=useState(false)
   const[showCnf,setShowCnf]=useState(false)
   const [config, setConfig] = useState({});
   const [btnLoader, setBtnLoader] = useState(false);
   const[activeLoad,setActiveLoad]=useState(false)
   const [passwordInput, setPasswordInput] = useState({
       password: '',
       confirmPassword: ''
   })

   // const [menus, setMenus] = useState([]);
   const [email, setEmail] = useState([]);
   const [locData,setLocData] = useState("");

   const {welcomeMsg, setWelcomeMsg,GetClientDataContext,setBusinessData,setClientInfo,setUserData,setUploadLogo,setProfileData,clientInfo,setActiveMenuId} = useContext(contentContext)

   const { menus } = useContext(contentContext);
   useEffect(() => {
    getuser()
       // appMenus();
       // getUserData();
    //    setEmail(localStorage.getItem("emailid"))
    //    setLocData(JSON.parse(localStorage.getItem("loc")));
   }, []);
   useEffect(() => {
       if(window.site){
         setConfig(window.site);
        
       }
      
     }, [window.site]);
   
     if(config.common && config.common.imagesCDN ){
       let img = config.common.imagesCDN;
     }
   // const appMenus = async () => {
   //     try {
   //         console.log(tmdbApi);
   //         const response = await tmdbApi.appMenus({result : "micro"});
   //         setMenus(response.result)
   //         console.log(response);
   //     } catch {
   //         console.log("error");
   //     }
   // };

   useEffect(() => {

    if (window.site === undefined) {
        setTimeout(() => {
            if (window.site && window.site.common && window.site.common.imageCloudfront) {
                setImg(window.site.common.imageCloudfront)
            }
        }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
        setImg(window.site.common.imageCloudfront)
    }


}, [window.site]);

   const queryString = window.location.search;
   const urlParams = new URLSearchParams(queryString);
   const id = urlParams.get("id");

 const getUserData = async () => {
   console.log('getuserdata');
   try {
       const response = await axios.get(`${lambda}/clientInfo?appname=${appname}&clientid=${id}`);
       console.log('response', response);

       const resultArray = response?.data?.result;

       if (response?.data?.result === "Client not found") {
           setEmail("");
           navigate("/");
       } else if (Array.isArray(resultArray) && resultArray.length > 0) {
           console.log("resp", response);
           setEmail(resultArray[0]?.email || "");
       } else {
           setEmail("");
           navigate("/");
           console.log("emaillllllllllllllllllllllllllll",email)
       }
   } catch (error) {
       console.error("Error fetching user data:", error);
       // setEmail(""); // Reset email in case of an error
       // navigate("/");
   }
};

const getuser = (e) => {
    // GetTimeActivity()   
    const token = localStorage.getItem("token")
    axios({
        method: 'GET',
        url: lambda + '/clientUserInfo?appname=' + appname+"&clientid="+id 
    })
        .then(function (response) {
            //  console.log("response", response?.data?.result?.[0]);
            if (response?.data?.result==="Invalid token or Expired") {
            //   setShowSessionPopup(true)
            }
            else {
                if (response?.data?.result.length > 0) {
                  setEmail(response?.data?.result?.[0]?.emailId);
                    
                } else {
                    // setInvalidContent(true)
                }
            }
            // getPermissions(response?.data && response?.data?.result && response?.data?.result?.[0] && response?.data?.result?.[0]?.type)
        });
}
   const handlePasswordChange = (evnt) => {
       const passwordInputValue = evnt.target.value.trim();
       const passwordInputFieldName = evnt.target.name;
       const NewPasswordInput = { ...passwordInput, [passwordInputFieldName]: passwordInputValue }
       setPasswordInput(NewPasswordInput);

   }
   const handleAddclass = (evnt) => {
       let element = document.getElementById("instruction");
       element.classList.add("ins-dsp-none");
       setConfirmPasswordError("");
   }
   const handleRemoveclass = (evnt) => {
       let element = document.getElementById("instruction");
       element.classList.remove("ins-dsp-none");
   }
   // const handleConfirm = (evnt) => {
   //     const passwordInputFieldName = evnt.target.name;
   //     if (passwordInputFieldName === "confirmPassword" || (passwordInputFieldName === "password")) {
             
   //         if (passwordInput.confirmPassword !== passwordInput.password) {
   //             setConfirmPasswordError("Confirm password is not matched");
   //         } else {
   //             setConfirmPasswordError("");
   //         }

   //     }
   // }
   const getStore = (result) => {
    // GetTimeActivity()
    // const token = localStorage.getItem("token")
    axios({
      method: 'POST',
      url: `${lambda}/getStores?appname=${appname}&clientid=${result?.clientid}`,
      // + "&token=" + token,
    })
      .then(function (response) {
        if (response?.data?.result === "Invalid token or Expired") {
          // setShowSessionPopupup(true)
        } else {
          if (response?.data?.result) {
            const result = response?.data?.result?.[0];
            if (result && result != "") {
              navigate("/dashboard")
            // navigate("/locations")
            } else {
              navigate("/addstore")
            }
            // setStoreData(result)
          } else {
            // setInvalidContent(true)
          }

        }

        // setDisableSaveBtn(false)
      });
  }
  const GetClientData = async () => {
    try {
      const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
  
      const response = await tmdbApi.getClientUserData({});
      const clientInfo = await tmdbApi.getClientInfo({});
      const client = clientInfo?.result?.[0];
  
      if (response?.statusCode === 200) {
        const user = response?.result?.[0];
        const userType = user?.usertype;
        const permissions = user?.permissions || [];
  
        // Set user data
        setUserData(user);
        setUploadLogo(user?.logo);
        setClientInfo(client)
        setBusinessData(client)
        setProfileData(user)
        console.log("userrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr",user)
        // Save basic info in localStorage
        localStorage.setItem("ClientName", user?.name || "");
        localStorage.setItem("ClientType", user?.type || "");
  
        // Function to navigate to the first visible menu
        const navigateToFirstVisibleMenu = () => {
          const visibleMenus = permissions.filter(item => item.display && item.menu);
          if (visibleMenus.length > 0) {
            const firstMenu = visibleMenus[0];
            const menuId = firstMenu.menu.split(" ").join("").toLowerCase();
            navigate("/" + menuId);
            setActiveMenuId(firstMenu.menuid);
          }
        };
  
        // Conditional routing based on user type
        if (userType === "STORE MANAGER" || userType === "SECURITY") {
          navigateToFirstVisibleMenu();
        } else {
            

          const isSubscriptionValid = client?.subscriptionPayment === "PAYMENT SUCCESS";
  
          if (isSubscriptionValid) {
            getStore(user);
          } else {
            navigate("/subscription");
          }
  
          // Optionally navigate to dashboard
          // navigate("/dashboard");
        }
  
        // Create collapsed submenu state (if needed)
        const submenuState = permissions.reduce((acc, item) => {
          if (item.submenus) {
            acc[item.menu] = false;
          }
          return acc;
        }, {});
        
        // Use submenuState if needed
        // setSubmenuState(submenuState);
      }
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };
  
   const handleValidation = (evnt) => {
       const passwordInputValue = evnt.target.value.trim();
       const passwordInputFieldName = evnt.target.name;
       //for password 
       if (passwordInputFieldName === 'password') {
           const uppercaseRegExp = /(?=.*?[A-Z])/;
           const lowercaseRegExp = /(?=.*?[a-z])/;
           const digitsRegExp = /(?=.*?[0-9])/;
           const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
           const minLengthRegExp = /.{8,}/;
           const passwordLength = passwordInputValue.length;
           const uppercasePassword = uppercaseRegExp.test(passwordInputValue);
           const lowercasePassword = lowercaseRegExp.test(passwordInputValue);
           const digitsPassword = digitsRegExp.test(passwordInputValue);
           const specialCharPassword = specialCharRegExp.test(passwordInputValue);
           const minLengthPassword = minLengthRegExp.test(passwordInputValue);
           let errMsg = "";
           if (passwordLength === 0) {
               errMsg = "Password is empty";
           }
           // else if (!uppercasePassword) {
           //     errMsg = "At least one Uppercase";
           // } else if (!lowercasePassword) {
           //     errMsg = "At least one Lowercase";
           // } else if (!digitsPassword) {
           //     errMsg = "At least one digit";
           // } else if (!specialCharPassword) {
           //     errMsg = "At least one Special Characters";
           // } else if (!minLengthPassword) {
           //     errMsg = "At least minumum 8 characters";
           // } else {
           //     errMsg = "";
           // }
           if (uppercasePassword) {
               var element = document.getElementById("err1");
               element.classList.add("vaild");
               setUpper(true);
           } else {
               var element = document.getElementById("err1");
               element.classList.remove("vaild");
               setUpper(false);
           }
           if (lowercasePassword) {
               var element = document.getElementById("err");
               element.classList.add("vaild");
               setLower(true);
           } else {
               var element = document.getElementById("err");
               element.classList.remove("vaild");
               setLower(false);
           }
           if (digitsPassword) {
               var element = document.getElementById("err2");
               element.classList.add("vaild");
               setNumber(true);
           } else {
               var element = document.getElementById("err2");
               element.classList.remove("vaild");
               setNumber(false);
           }
           if (specialCharPassword) {
               var element = document.getElementById("err3");
               element.classList.add("vaild");
               setSpecial(true)
           } else {
               var element = document.getElementById("err3");
               element.classList.remove("vaild");
               setSpecial(false)
           }
           if (minLengthPassword) {
               var element = document.getElementById("err4");
               element.classList.add("vaild");
               setLimit(true)
           } else {
               var element = document.getElementById("err4");
               element.classList.remove("vaild");
               setLimit(false)
           }
           if (limit && upper && special && lower && number && confirmPasswordError === "") {
               setError("")
           }

          
           setPasswordErr(errMsg);
       }
       // for confirm password
       // if (passwordInputFieldName === "confirmPassword" || (passwordInputFieldName === "password")) {
             
       //     if (passwordInput.confirmPassword !== passwordInput.password) {
       //         setConfirmPasswordError("Confirm password is not matched");
       //     } else {
       //         setConfirmPasswordError("");
       //     }

       // }
   }
   const togglePassword = (e) => {
       setPasswordShown(!passwordShown);
   };

   const handlePwdGenerate = (e) => {
     
       if(passwordInput.password===""){
           if(id){
               setError("Please Enter New Password");
               setTimeout(function () { setError("") }, 4000);
           }else{
               setError("Please Enter Password");
               setTimeout(function () { setError("") }, 4000);
           }
           
           

       }else if(passwordInput.confirmPassword === ""){
           setError("Please Enter Confirm Password");
           setTimeout(function () { setError("") }, 4000);

       }
       else if (passwordInput.confirmPassword !== passwordInput.password) {
           setConfirmPasswordError("Confirm password is not matched");
           // setTimeout(function () { setConfirmPasswordError("") }, 3000);
       }
       //else if(lower === false && number === false && limit === false && lower === false && special === false){
       //     setError("Please Enter Strong Password");
       //     setTimeout(function () { setError("") }, 3000);

       // }
      else if (!limit || !upper || !special || !lower || !number){
     
           setError("Please enter the password as per the instructions");
           // setTimeout(function () { setError("") }, 3000);
       
    }
      else if (limit && upper && special && lower && number && confirmPasswordError === "") {
       setError("")
       
         if(passwordInput.password === passwordInput.confirmPassword){
           setConfirmPasswordError("")
           
           pwdGenerate();
         }
       }
    
   }

   const pwdGenerate = async () => {
       setBtnLoader(true);
       try {
           const response = await tmdbApi.pwdGenerate({
               "emailId": email,
               "password": passwordInput.password,
           });
   
           console.log("Response:", response);
   
           if (response?.result?.token) {
               window.localStorage.setItem("token", response.result.token);
               // window.localStorage.setItem("login", "setlogin");
               window.localStorage.setItem("clientid", response.result.clientid);
   
               let currentDate = new Date().toJSON();
               window.localStorage.setItem("currentSessionClientTime", currentDate);
   
               // setWelcomeMsg(true);
            //    navigate("/dashboard");  // Ensure navigation is executed if token exists
               GetClientData()
           } else {
               console.warn("Token not found in response:", response);
           }
       } catch (error) {
           console.error("Error during password generation:", error);  // Logs actual error
       } finally {
           setBtnLoader(false);
       }
   };
   

   function handleClose() {
       navigate("/");
   }

    


  

    return (
        <>
            {/* <Modal className="access-denied" show={showSessionPopup} >

                <div className="modal-body enquiry-form">
                    <div className="container">
                        <button className="close-btn" onClick={e => onCancel()}><span className="material-icons">close</span></button>
                        <span className="material-icons access-denied-icon">https</span>
                        <span className="material-icons access-denied-icon">
                            web_asset_off
                        </span>
                        <h3>Multiple Sessions Found</h3>
                        <p>Another session is running in another browser. Do you want to terminate that session?</p>
                        <div className="popup-footer">
                            <button className="fill_btn yellow-gradient" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={e => signoutsession()}>{BtnLoader==="sessionLoad" ? (<img src={image+"orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />) : null}Yes</button>
                            <button className="fill_btn" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={e => onCancel()}>No</button>
                        </div>
                    </div>
                </div>

            </Modal> */}

           
         
{/* <div className="signin-wrapper generate_password">
  <button className="close-btn" id="close-button" onClick={handleClose}>
     <span className="material-icons">close</span>
  </button>
  <div className="logo_section">
     <a href="/">
        <img 
           src={`${image}${appname}/images/web/logo-dark.png`} 
           className="logo" 
           id="logo-image"
        />
     </a>
  </div>
  <p className="strong" id="password-instruction">
     Create strong and secure passwords to keep your account safe
  </p>
  <div className="material-icons-outlined secure-icon" id="lock-icon">lock_person</div>
  <div className="crpsd-cnt-blk">
     <div className="create-password-body">
        <div className="signin-section">
           <label className="form_label" htmlFor="email-input">EMAIL</label>
           <div className="input-group mb-3 mr-sm-2">
              <div className="input-group-prepend">
                 <div className="input-group-text">
                    <span className="material-symbols-outlined">mail</span>
                 </div>
              </div>
              <input 
                 type="email" 
                 className="form-control" 
                 id="email-input" 
                 value={email} 
                 placeholder={email} 
              />
           </div>

           <label className="form_label" htmlFor="password-input">New Password</label>
           <div className="input-group mb-3 mr-sm-2">
              <div className="input-group-prepend">
                 <div className="input-group-text">
                    <span className="material-symbols-outlined">lock</span>
                 </div>
              </div>
              <input 
                 type={showPwd ? "text" : "password"} 
                 value={passwordInput.password} 
                 id="password-input" 
                 onChange={handlePasswordChange} 
                 onKeyUp={handleValidation} 
                 name="password" 
                 placeholder="Password" 
                 className="form-control" 
                 onBlur={handleAddclass} 
                 onFocus={handleRemoveclass} 
              />
              <div className="input-group-text" id="togglePasswordVisibility">
              <span onClick={() => setShowPwd(!showPwd)} className="material-symbols-outlined">
                 {showPwd ? "visibility_off" : "visibility"}
              </span>
              </div>
              <p className="errormsg" id="password-error">{passwordError}</p>
           </div>

           <label className="form_label" htmlFor="confirm-password-input">Confirm Password</label>
           <div className="input-group mb-3 mr-sm-2">
              <div className="input-group-prepend">
                 <div className="input-group-text">
                    <span className="material-symbols-outlined">lock</span>
                 </div>
              </div>
              <input 
                 type={showCnf ? "text" : "password"} 
                 value={passwordInput.confirmPassword} 
                 onChange={handlePasswordChange} 
                 id="confirm-password-input"
                 onBlur={handleAddclass}
                 onFocus={handleRemoveclass} 
                 name="confirmPassword" 
                 placeholder="Confirm Password" 
                 className="form-control" 
              />
              <div className="input-group-text" id="togglePasswordVisibility">
              <span onClick={() => setShowCnf(!showCnf)} className="material-symbols-outlined">
                 {showCnf ? "visibility_off" : "visibility"}
              </span>
              </div>
              <p className="errormsg" id="confirm-password-error">{confirmPasswordError}</p>
           </div>

           <p className="errormsg" id="general-error" style={{ top: "-3px", position: "relative" }}>
              {error}
           </p>

           <div className="signin-footer mt-3">
              <button className="fill-btn" id="create-password-button" onClick={handlePwdGenerate}>
                 {btnLoader ? (
                    <img 
                       src={`${image}${appname}/images/web/rotate_right.svg`}
                       className="loading-icon" 
                    />
                 ) : null}
                 Create Password
              </button>
           </div>
        </div>
     </div>

     <div className="create-password-instruction ins-dsp-none" id="instruction">
        <p className="error" id="err">{lower ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a lower case letter</p>
        <p className="error" id="err1">{upper ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain an upper case letter</p>
        <p className="error" id="err2">{number ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a number</p>
        <p className="error" id="err3">{special ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a special character or a space</p>
        <p className="error" id="err4">{limit ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain at least 8 characters</p>
     </div>
  </div>
</div> */}
 <div className="signin-wrapper" id="signin-wrapper">
           <div className="logo_section" id="logo-section">
               <img
                   src={`${image}${appname}/images/web/logo-dark.png`}
                   className="logo"
                   id="signin-logo"
               />
               <button className="close-btn" onClick={handleClose} id="signin-close-btn">
                   <span className="material-icons">close</span>
               </button>
           </div>
           <div className="signin-body" id="signin-body">
               <div className="signin-graphic" id="signin-graphic">
                   <img
                       src={`${image}${appname}/images/web/Recover-Password-Graphic.svg`}
                       id="signin-graphic-img"
                   />
                   <h3 id="onboarding-title">Seamless Onboarding</h3>
                   <p id="onboarding-subtitle">Successful Beginnings: Your Journey Starts Here!</p>
               </div>

<div className="signin-section generate-password-wrapper"> 
<h1 className="bold-heading" id="defaultHeading">Generate Password</h1>
<p id="defaultInstruction">Create Strong and Secure to Keep your account Safe</p>

      <div className="input_group_wrapper">
    <label className="form_label d-flex">Email</label>
    <div className="input_group">
        <div className="icon_wrapper">
        <span className="material-symbols-outlined">mail</span>
        </div>
        <input type="text" className="form-control" id="email-input"  value={email}  placeholder="Enter your email" disabled />
    </div>
</div>

   
    <div className="input_group_wrapper mt-4">
    <label className="form_label d-flex">Password</label>
    <div className="input_group">
        <div className="icon_wrapper">
        <span className="material-symbols-outlined">lock</span>
        </div>
        <input  type={showPwd ? "text" : "password"} 
                 value={passwordInput.password} 
                 id="password-input" 
                 onChange={handlePasswordChange} 
                 onKeyUp={handleValidation} 
                 name="password" 
                 placeholder="Password" 
                 className="form-control padding-right"
                 onBlur={handleAddclass} 
                 onFocus={handleRemoveclass} />


        <span  id="togglePasswordVisibility" onClick={() => setShowPwd(!showPwd)} onKeyDown={keyActivate(() => setShowPwd(!showPwd))} className="material-symbols-outlined lock-style">{showPwd ? "visibility_off" : "visibility"}</span>
        </div>
        <span className="errormsg" id="password-error">{passwordError}</span> 
</div>
  
      <div className="input_group_wrapper mt-4">
    <label className="form_label d-flex">Confirm Password</label>
    <div className="input_group">
        <div className="icon_wrapper">
        <span className="material-symbols-outlined">lock</span>
        </div>
        <input  type={showCnf ? "text" : "password"} 
                 value={passwordInput.confirmPassword} 
                 onChange={handlePasswordChange} 
                 id="confirm-password-input"
                 onBlur={handleAddclass}
                 onFocus={handleRemoveclass} 
                 name="confirmPassword" 
                 placeholder="Confirm Password" 
                 
                 className="form-control padding-right"
               />


        <span  id="togglePasswordVisibility" onClick={() => setShowCnf(!showCnf)} onKeyDown={keyActivate(() => setShowCnf(!showCnf))} className="material-symbols-outlined lock-style"> {showCnf ? "visibility_off" : "visibility"}</span>
        </div>
        <span className="errormsg" id="general-error" >
              {error}
           </span>
    <span className="errormsg" id="confirm-password-error">{confirmPasswordError}</span>
</div>
    

    <div className="signin-footer mt-3">
    <button className="fill-btn" id="create-password-button" onClick={handlePwdGenerate} disabled={btnLoader}>
                 {btnLoader ? (
                    <img 
                       src={`${image}${appname}/images/web/rotate_right.svg`}
                       className="loading-icon" 
                    />
                 ) : null}
                 Create Password
              </button>
       
    </div>
</div>
<div className="create-password-instruction ins-dsp-none" id="instruction">
        <p className="error" id="err">{lower ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a lower case letter</p>
        <p className="error" id="err1">{upper ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain an upper case letter</p>
        <p className="error" id="err2">{number ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a number</p>
        <p className="error" id="err3">{special ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a special character or a space</p>
        <p className="error" id="err4">{limit ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain at least 8 characters</p>
     </div>





          
     
           </div>
        
       </div>

<footer className="login_footer">
  <div className="container-fluid">
     <p className="footer-para" id="footer-text"> © {new Date().getFullYear()} SpotSaver. All rights reserved.</p>
  </div>
</footer>

        </>
    );
};

export default GeneratePassword;
